import link from '@/mixins/link'
import auth from '@/mixins/auth'
import localStorage from 'store'
import i18n from '@/i18n'

const languageKey = 'language'

export default {
  mixins: [auth, link],
  data: function () {
    return {
      language: {}
    }
  },
  watch: {
    '$i18n.locale': function () {
      // this tells the store what version of the categories to choose
      this.$store.dispatch('updateSelectedLanguage', this.$i18n.locale)
      this.setLanguage()
    },
    isLoggedIn: function () {
      if (this.$isYSC) {
        this.checkLanguage()
      }
    }
  },
  mounted: function () {
    this.setLanguage()
    if (this.$isYSC) {
      if (this.queryLanguage === 'fr' || this.queryLanguage === 'en') {
        this.saveLanguage(this.queryLanguage)
      } else {
        this.checkLanguage()
      }
    }
  },
  computed: {
    isFrench: function () {
      return this.$i18n.locale === 'fr'
    },
    queryLanguage: function () {
      if (window.location.search.includes('lang=en')) {
        return 'en'
      } else if (window.location.search.includes('lang=fr')) {
        return 'fr'
      }
      return null
    }
  },
  methods: {
    saveLanguage: function (selectedLanguage) {
      if (!selectedLanguage) {
        return
      }
      this.$i18n.locale = selectedLanguage
      this.toggleLanguage(this.isFrench)
      if (this.isLoggedIn) {
        const settings = { language: selectedLanguage }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      } else {
        localStorage.set(languageKey, selectedLanguage)
      }
    },
    checkLanguage: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'language').then((languageSetting) => {
          this.$i18n.locale = languageSetting
        })
      } else {
        const languageSetting = localStorage.get(languageKey)
        if (languageSetting) {
          this.$i18n.locale = languageSetting
        }
      }
      if (this.queryLanguage === 'fr' || this.queryLanguage === 'en') {
        this.saveLanguage(this.queryLanguage)
      }
    },
    toggleLanguage: function (isFrench) {
      this.$set(this.language, 'title', isFrench ? i18n.t('footer.english') : i18n.t('footer.french'))
      this.$set(this.language, 'abbr', isFrench ? 'en' : 'fr')
      this.$set(this.language, 'key', isFrench ? 'en' : 'fr')
    },
    setLanguage: function () {
      switch (this.app) {
        case 'ysc':
          this.toggleLanguage(this.isFrench)
          break
        case 'neweng':
          this.$set(this.language, 'title', i18n.t('footer.deutsch'))
          this.$set(this.language, 'abbr', 'de')
          this.$set(this.language, 'href', 'https://www.engineering.com/deutsch')
          break
        default:
          break
      }
    }
  }
}
